import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=2afbbcc8&"
import script from "./Key.vue?vue&type=script&lang=ts&"
export * from "./Key.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports